module.exports = __webpack_public_path__ + "static/closed-caption-example.dd24535d.jpg";